export function formatPrice(cents, currency = 'MXN') {
    return `$${(cents / 100).toFixed(2)} ${currency}`;
}
export function formatPriceAmount(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}
